import { useParams } from "react-router";
import CredMgmtSetPassword from "../../components/CredMgmtSetPassword/CredMgmtSetPassword";
import MsCredMgmtSetPassword from "../../components/MsCredMgmtSetPassword/MsCredMgmtSetPassword";

function CredMgmtSetPasswordPage() {
  const { tenant } = useParams();
  const theme = `${tenant}-theme`;

  return (
    <>
      <div className={theme} data-testid="theme-name">
        {tenant == "ms1" ? <MsCredMgmtSetPassword /> : <CredMgmtSetPassword />}
      </div>
    </>
  );
}

export default CredMgmtSetPasswordPage;
